import { mergeInventoryMetadata } from './inventory-shared-catalog';
import type { FromBasePlayerInput, FromBaseRow } from './from-base-context';
import { fromBaseClone, fromBaseUuid, FromBaseStageMissing } from './from-base-context';
import type { FromBasePlayerResourceMetadata } from './from-base-player-resources';
import { createFromBasePlayerStageContext } from './from-base-player-stages';
import { createNpcDefinitionFinalizer } from './from-base-npc-finalization';
import { readItemUuidSlot } from './inventory-raw-readers';

/** One shared full-definition prerequisite for PC providers and prepared spells. */
export function createPlayerDefinitionFinalizer(base: FromBasePlayerInput, metadata: FromBasePlayerResourceMetadata, stage: string) {
    if (metadata.definitionLookup) return (id: string, _label: string) => metadata.definitionLookup!(id);
    if (!metadata.inventoryMetadata) throw new FromBaseStageMissing(stage, 'definition-metadata');
    const finalize = createNpcDefinitionFinalizer(base as unknown as FromBaseRow, metadata, mergeInventoryMetadata(metadata.inventoryMetadata!, base.inventory_metadata));
    return (id: string, _label: string): FromBaseRow | null => finalize.definition(id, []);
}

/** A partial definition is never attached as a finished provider. */
export function constructPlayerSaveSectionsFromBase(base: FromBasePlayerInput, metadata: FromBasePlayerResourceMetadata, input: FromBaseRow): FromBaseRow {
    const host = fromBaseClone(input), { readers } = createFromBasePlayerStageContext(base, metadata);
    const finalize = createPlayerDefinitionFinalizer(base, metadata, 'save-section-definition-finalization');
    const pc = host.player_characters as FromBaseRow;
    for (const slot of ['ancestry_1', 'ancestry_2', 'lineage', 'background', ...Array.from({ length: 20 }, (_, index) => [`class_${index + 1}`, `subclass_${index + 1}`]).flat()]) {
        const id = readItemUuidSlot(readers.itemField(base.player_characters, slot));
        if (!fromBaseUuid(id)) continue;
        const row = finalize(id, slot);
        if (row) pc[slot] = row;
    }
    return host;
}
